import React, { lazy, Suspense } from "react";
import { Box, Card, Typography, CardActionArea, Dialog } from "@mui/material";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { CreateUserSkeleton } from "../../components/common/DialogSkeleton";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
const CreateUserForm = lazy(() => import("./CreateUserForm"));

const t = {
  cardBg: "#ffffff",
  border: "#e0daf0",
  borderHover: "#a89cd4",
  accent: "#6c5ce7",
  accentLight: "#f0edfd",
  accentMid: "#ece8fb",
  textPrimary: "#1a1a2e",
  textSecondary: "#6b6b80",
  radius: "12px",
  radiusSm: "8px",
};

const CreateUserTile = () => {
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  return (
    <>
      <Check I={CAN.CREATE} a={SUBJECTS.RELEASE}>
        <CardActionArea
          onClick={handleOpen}
          sx={{ borderRadius: t.radius, height: "100%" }}
        >
          <Card
            variant="outlined"
            sx={{
              background: t.cardBg,
              border: `1.5px dashed ${t.border}`,
              borderRadius: t.radius,
              boxShadow: "none",
              p: 2.5,
              display: "flex",
              alignItems: "center",
              gap: 2,
              height: "100%",
              transition: "all 0.18s ease",
              "&:hover": {
                border: `1.5px dashed ${t.accent}`,
                background: t.accentLight,
              },
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: "14px",
                background: t.accentMid,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                transition: "background 0.18s ease",
                ".MuiCardActionArea-root:hover &": {
                  background: t.accentLight,
                },
              }}
            >
              <PersonAddAltOutlinedIcon sx={{ color: t.accent, fontSize: 26 }} />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: t.accent,
                  letterSpacing: "0.02em",
                }}
              >
                Create a User
              </Typography>
              <Typography
                sx={{
                  fontSize: "11px",
                  color: t.textSecondary,
                  mt: 0.3,
                }}
              >
                Add a new user to the portal
              </Typography>
            </Box>
          </Card>
        </CardActionArea>
      </Check>

      <Dialog
        open={openModal}
        onClose={handleClose}
        fullWidth
        scroll="paper"
        PaperProps={{
          style: {
            maxHeight: "90%",
            borderRadius: t.radius,
          },
        }}
      >
        <Suspense fallback={<CreateUserSkeleton />}>
          <CreateUserForm onUserCreated={handleClose} />
        </Suspense>
      </Dialog>
    </>
  );
};

export default CreateUserTile;